import React from 'react';
import LoginForm from '../components/LoginForm';

export default function LoginPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', minHeight: '100vh', padding: '260px 0 0 60px', maxWidth: 400 }}>
      <LoginForm />
    </div>
  );
}
